import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { MyDocumentsCard, FileUpload } from '../components';
import './CourseDocumentsPage.css';

export default function CourseDocumentsPage(){
  const { courseId } = useParams();
  const navigate = useNavigate();
  const courseIdNum = Number(courseId);
  const [refreshKey, setRefreshKey] = useState(0);
  return (
    <div className="course-documents-page-container">
      <header className="course-documents-page-header">
  <button className="zoom-back-btn btn btn-outline btn-sm" onClick={()=>navigate(-1)}><span className="icon" aria-hidden="true">⤢</span> Back</button>
        <h1 className="course-documents-page-title">Course Documents</h1>
      </header>
      <div className="course-documents-page-grid">
        <div className="course-doc-upload">
          <FileUpload endeavorId={courseIdNum} onUploadComplete={()=>setRefreshKey(k=>k+1)} />
        </div>
        <div className="course-doc-list">
          <MyDocumentsCard endeavorId={courseIdNum} refreshKey={refreshKey} maxItems={200} />
        </div>
      </div>
    </div>
  );
}
